import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { isChunkLoadError, attemptChunkReload } from "./lib/chunkReload";

initSentry();

// Stale-chunk auto-recovery (safety net pro chyby mimo lazy boundary, např. async
// CSS/script). Detekce i reload jsou centralizované v ./lib/chunkReload — JEDEN
// cache-busting reload s JEDNÍM guardem (sdílený s lazyWithRetry + PageErrorBoundary).
function maybeReloadOnStaleChunk(err: unknown) {
  if (isChunkLoadError(err)) attemptChunkReload();
}
window.addEventListener('error', (e) => maybeReloadOnStaleChunk(e.error || e.message));
window.addEventListener('unhandledrejection', (e) => maybeReloadOnStaleChunk(e.reason));

createRoot(document.getElementById("root")!).render(<App />);
